import React, { Fragment } from 'react';
import HighlightIcon from '../HighlightIcon';

export default function VerticalAPR({
  highlights,
  facility,
  size = null,
  airportinitials,
  isCity,
  ...props
}) {
  const checkedHighlights = highlights.filter((highlight) => highlight.check);

  const getHighlight = (type) =>
    checkedHighlights.find((h) => h.type === type);

  const notes = getHighlight('facility_additional_comments');
  const evCharger = getHighlight('facility_eletric_car');

  return (
    <>
      <div
        className="flex flex-col gap-0.5 justify-center items-start"
        {...props}
      >
        {isCity ?
          <>
            {
              checkedHighlights.map((highlight, index) => (
                <Fragment key={highlight.type + index}>

                  {highlight.type === 'facility_open_hour' && (
                    <div className="flex flex-row justify-center items-center">
                      <HighlightIcon
                        type="open_hour"
                        width={16}
                        height={16}
                        stroke="#434343"
                      />
                      <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                        Free Shuttle
                      </p>
                      {highlight.description && (
                        <p className="text-center text-[0.75rem] max-w-xs md:max-w-[17rem]">
                          {highlight.description}
                        </p>
                      )}
                    </div>
                  )}
                  {highlight.type === 'facility_accessibility' && (
                    <div className="flex flex-row justify-center items-center">
                      <HighlightIcon
                        type="accessible"
                        width={16}
                        height={16}
                        fill="#434343"
                      />
                      <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                        Wheelchair Accessible
                      </p>
                    </div>
                  )}
                  {highlight.type === 'facility_eletric_car' && (
                    <div className="flex flex-row justify-center items-center">
                      <div className="shrink-0">
                        <HighlightIcon
                          type="eletric_car"
                          width={16}
                          height={16}
                          fill="#434343"
                        />
                      </div>
                      <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                        EV Charger
                      </p>
                    </div>
                  )}
                  {highlight.type === 'facility_free_cancellation' && (
                    <div className="flex flex-row justify-center items-center">
                      <HighlightIcon
                        type="free-cancellations"
                        width={16}
                        height={16}
                        fill="#434343"
                      />
                      <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                        Free Cancellation
                      </p>
                    </div>
                  )}
                  {highlight.type === 'facility_additional_comments' && (
                    <div className="flex flex-row justify-center items-center">
                      <HighlightIcon
                        type="additional_comments"
                        width={16}
                        height={16}
                        fill="#434343"
                      />
                      <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                        Notes
                      </p>
                      {highlight.description && (
                        <p className="text-center text-[0.75rem] truncate max-w-xs md:max-w-[17rem]">
                          {highlight.description}
                        </p>
                      )}
                    </div>
                  )}
                </Fragment>
              ))
            }
          </>
          :
          (<>
            {checkedHighlights.map((highlight, index) => (
              <Fragment key={highlight.type + index}>

                {highlight.type === 'facility_free_shuttles' && (
                  <div className="flex flex-row justify-center items-center">
                    <HighlightIcon
                      type="free-shuttle"
                      width={16}
                      height={16}
                      fill="#434343"
                    />
                    <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                      Free Shuttle
                    </p>
                    {highlight.description && (
                      <p className="text-center text-[0.75rem]max-w-xs md:max-w-[17rem]">
                        {highlight.description}
                      </p>
                    )}
                  </div>
                )}
                {highlight.type === 'facility_no_shuttles' && (
                  <div className="flex flex-row justify-center items-center">
                    <HighlightIcon
                      type="no-free-shuttle"
                      width={16}
                      height={16}
                      fill="#434343"
                    />
                    <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                      No Shuttle
                    </p>
                    {highlight.description && (
                      <p className="text-center text-[0.75rem]max-w-xs md:max-w-[17rem]">
                        {highlight.description}
                      </p>
                    )}
                  </div>
                )}
                {airportinitials && (highlight.type === 'facility_distance') && (
                  <div className="flex flex-row justify-center items-center">
                    <HighlightIcon
                      type="distance"
                      width={16}
                      height={16}
                      fill="#434343"
                    />
                    {highlight.description ? (
                      <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                        {highlight.description} to {airportinitials}
                      </p>
                    ) : (
                      <p className="text-center text-[0.75rem]max-w-xs md:max-w-[17rem]">
                        {facility.facility_airport_distance}{' '}
                        {`${facility.facility_airport_distance === 1
                          ? 'mile'
                          : 'miles'
                          }`} to {airportinitials}
                      </p>
                    )}
                  </div>
                )}

                {highlight.type === 'facility_open_hour' && (
                  <div className="flex flex-row justify-center items-center">
                    <HighlightIcon
                      type="open_hour"
                      width={16}
                      height={16}
                      stroke="#434343"
                    />
                    <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                      Facility Access
                    </p>
                    {highlight.description && (
                      <p className="text-center text-[0.75rem]max-w-xs md:max-w-[17rem]">
                        {highlight.description}
                      </p>
                    )}
                  </div>
                )}
                {highlight.type === 'facility_free_cancellation' && (
                  <div className="flex flex-row justify-center items-center">
                    <HighlightIcon
                      type="free-cancellations"
                      width={16}
                      height={16}
                      fill="#434343"
                    />
                    <p className="text-[0.7rem] md:text-base text-center font-medium mx-2">
                      Free Cancellation
                    </p>
                    {highlight.description && (
                      <p className="text-center text-[0.75rem]max-w-xs md:max-w-[17rem]">
                        {highlight.description}
                      </p>
                    )}
                  </div>
                )}
              </Fragment>
            ))}
          </>)}
      </div>
    </>
  );
}
